<template>
  <config-base class="opc-webinar" ref="baseRef" :on="$listeners" show-plan-details>
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey"></capacity-config-list>
      <preview-payment class="opc-webinar__preview-payment" />
    </template>
  </config-base>
</template>

<script>
import {get, map} from "lodash";
import {mapGetters} from "vuex";
import planCommon from '@/plans/WEBINAR/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import {getNeedFilterCapacityList} from '@/common/product';
import {computedWebinarPlans} from "@/common/service/computers/plans/webinar";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/WEBINAR/config/base.vue";
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import replenishMixin from "@/components/capacity/mx/replenish";

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon, replenishMixin],
  computed: {
    ...mapGetters(['getCurrentMeetingPlans', 'getCurrentBasePlanInfo', 'boughtPlans', 'hasBoughtDependPlan']),
    addAnotherCapacityCta() {
      return this.$t('billing.addAnother.webinar');
    },
    boughtCurrentPlans() {
      return computedWebinarPlans(this.boughtPlans)
    },
    planList() {
      return this.planMapFlat.filter((p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isSupportCapacity = this.supportCapacity.includes(p[this.capacityKey]);
        const isBoughtCapacity = map(this.boughtCurrentPlans, this.capacityKey).includes(p[this.capacityKey]);
        const needFilterCapacity = getNeedFilterCapacityList(this.getCurrentBasePlanInfo?.plans).includes(p[this.capacityKey])
        return isCurrentPlanType && isSupportCapacity && !needFilterCapacity && !isBoughtCapacity;
      });
    },
    mx_showSelectCapacityDropdown() {
      return this.allCapacityOrderList.length !== 1;
    },
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    editTotalLimitDesc() {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'parentPlanNameKey']) || get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey'])
      return this.$t(
        this.hasBoughtDependPlan ?
          'billing.addon_license_limit_tips' :
          'billing.addon_license_limit_tips_without_contact',
        [this.title || this.$t('billing.webinar.title'), this.$t(basePlanNameKey)])
    }
  },
  methods: {
    handleLicenseChange(license, capacity) {
      const condition = license >= this.mx_getMaxHosts() && this.mx_getMaxHosts() !== 999;
      this.$set(this.mx_license_capacityAlertMap, capacity, condition ? this.editTotalLimitDesc : "");
    },
    showMessage(message) {
      this.msgInstance && this.msgInstance.close();
      this.msgInstance = this.$message({
        type: 'info',
        duration: 8000,
        message: message,
        showClose: true
      })
    },
    mx_getMaxHosts() {
      return this.mx_canAutoAdd ? 999 : (getPlanTotalLicense(this.currentBasePlans || []) || 999);
    },
    mx_getDeleteVisible(capacity){
      return !(
        this.selectedPlanList?.length === 1
        && capacity === this.selectedPlanList?.[0].capacity)
    },
    mx_onAddedBasePlan(basePlanName) {
      this.showMessage(
        this.$t('billing.addon_auto_add_tips', [this.$t('billing.webinar.title'), basePlanName]),
      );
    },
    mx_onRemovedBasePlan(basePlanName) {
      this.showMessage(
        this.$t('billing.addon_auto_remove_tips', [this.$t('billing.webinar.title'), basePlanName]),
      );
    }
  }
}
export default {
  mixins: [plansMixin, planCommon],
  components: { PreviewPayment, ConfigBase, CapacityConfigList }
};
</script>

<style lang='scss'>
.opc-webinar {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
